<template>
  <div id="overlay">
    <b-field class="my-1 transparentBG controlBorder" grouped>
      <b-tooltip class="control equalMargin" :label="$t('addQuestion')" type="is-primary">
        <b-button
          class="rounded"
          icon-left="plus"
          :disabled="isDisabled"
          :loading="isLoading"
          type="is-info"
          @click="addQuestion"
        />
      </b-tooltip>
      <div class="questionOverlay control">
        <b-tooltip class="control equalMargin" :label="$t('previousQuestion')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="chevron-left"
            type="is-primary"
            :disabled="!previousAvailable || isDisabled"
            :loading="isLoading"
            @click="previousQuestion"
          />
        </b-tooltip>
        <b-button class="mt-3 mr-3" :disabled="isDisabled">
          {{ "questionTitle" }}
        </b-button>
        <b-tooltip v-if="!questionOpen" class="control equalMargin" :label="$t('openQuestion')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="play"
            :disabled="isDisabled"
            :loading="isLoading"
            type="is-success"
            @click="openQuestion"
          />
        </b-tooltip>

        <b-tooltip v-if="questionOpen" class="control equalMargin" :label="$t('closeQuestion')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="stop"
            :disabled="isDisabled"
            :loading="isLoading"
            type="is-danger"
            @click="closeQuestion"
          />
        </b-tooltip>
        <b-tooltip v-if="votingOpen" class="control equalMargin" :label="$t('disableVoting')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="lock"
            :disabled="isDisabled"
            :loading="isLoading"
            type="is-primary"
            @click="disableVoting"
          />
        </b-tooltip>
        <b-tooltip v-if="!votingOpen" class="control equalMargin" :label="$t('activateVoting')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="lock-open"
            :disabled="isDisabled"
            :loading="isLoading"
            type="is-primary"
            @click="activateVoting"
          />
        </b-tooltip>

        <b-tooltip v-if="resultsShown" class="control equalMargin" :label="$t('hideResults')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="signal-off"
            :disabled="isDisabled"
            :loading="isLoading"
            type="is-primary"
            @click="hideResults"
          />
        </b-tooltip>

        <b-tooltip v-if="!resultsShown" class="control equalMargin" :label="$t('showResults')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="signal"
            :disabled="isDisabled"
            :loading="isLoading"
            type="is-primary"
            @click="showResults"
          />
        </b-tooltip>

        <b-tooltip class="control equalMargin" :label="$t('nextQuestion')" type="is-primary">
          <b-button
            class="rounded"
            icon-left="chevron-right"
            type="is-primary"
            :disabled="!nextAvailable || isDisabled"
            :loading="isLoading"
            @click="nextQuestion"
          />
        </b-tooltip>

        <b-tooltip class="control equalMargin" :label="$t('settings')" type="is-primary">
          <b-button class="rounded" icon-left="cog" type="is-primary" />
        </b-tooltip>

        <b-tooltip v-if="!fullscreen" class="control equalMargin" :label="$t('fullscreenOn')" type="is-primary">
          <b-button class="rounded" icon-left="fullscreen" type="is-primary" @click="fullscreenOn" />
        </b-tooltip>

        <b-tooltip v-if="fullscreen" class="control equalMargin" :label="$t('fullscreenOff')" type="is-primary">
          <b-button class="rounded" icon-left="fullscreen-exit" type="is-primary" @click="fullscreenOff" />
        </b-tooltip>
      </div>
    </b-field>
  </div>
</template>

<script>
let elem = document.documentElement;
import { functions } from "@/firebase";

export default {
  name: "PresentationOverlay",
  props: {
    survey: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      shownQuestion: 0,
      fullscreen: false,
      test: null,
      isDisabled: false,
      isLoading: false,
    };
  },
  computed: {
    shownQuestionKey() {
      return 0;
    },
    currentQuestion() {
      return this.survey.questions[this.shownQuestion] || null;
    },
    questionOpen() {
      if (this.currentQuestion) {
        return !this.currentQuestion.closed; // && (this.currentQuestion == this.shownQuestionKey)
      }
      return false;
    },
    votingOpen() {
      if (this.currentQuestion) {
        return this.currentQuestion.opened && !this.currentQuestion.closed;
      }
      return false;
    },
    resultsShown() {
      if (this.currentQuestion) {
        return this.currentQuestion.showResults;
      }
      return false;
    },
    nextAvailable() {
      if (this.survey.questions.length > this.shownQuestion + 1) {
        return true;
      }
      return false;
    },
    previousAvailable() {
      if (this.shownQuestion > 0) {
        return true;
      }
      return false;
    },
  },
  watch: {},
  mounted() {
    /*let vm = this
    let overlay = document.getElementById('overlay')
    document.onclick = function(e) {
      let target = (e && e.target) || (event && event.srcElement)
      let dontDeactivate = false
      while (target.parentNode) {
        if (target == overlay) {
          dontDeactivate = true
          break
        }
        target = target.parentNode
      }
      if (!dontDeactivate) {
        vm.clearOverlays()  
      }
    }*/
  },
  methods: {
    addQuestion() {},
    async openQuestion() {
      try {
        this.isDisabled = true;
        this.isLoading = true;
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: this.shownQuestion,
          status: "openQuestion",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async closeQuestion() {
      try {
        this.isLoading = true;
        this.isDisabled = true;
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: this.shownQuestion,
          status: "closeQuestion",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async disableVoting() {
      try {
        this.isLoading = true;
        this.isDisabled = true;
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: this.shownQuestion,
          status: "stopVote",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async activateVoting() {
      try {
        this.isLoading = true;
        this.isDisabled = true;
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: this.shownQuestion,
          status: "startVote",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async showResults() {
      try {
        this.isLoading = true;
        this.isDisabled = true;
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: this.shownQuestion,
          status: "showResults",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async hideResults() {
      try {
        this.isLoading = true;
        this.isDisabled = true;
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: this.shownQuestion,
          status: "hideResults",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    previousQuestion() {
      if (this.shownQuestion > 0) {
        this.shownQuestion -= 1;
      }
    },
    nextQuestion() {
      if (this.survey.questions.length > this.shownQuestion + 1) {
        this.shownQuestion += 1;
      }
    },
    fullscreenOn() {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      this.fullscreen = true;
    },
    fullscreenOff() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.fullscreen = false;
    },
  },
};
</script>

<style scoped>
.transparentBG {
  background-color: #ccff23;
}
.equalMargin {
  margin-top: 12px;
  margin-bottom: 12px;
  margin-right: 12px;
}
.controlBorder {
  padding-left: 12px;
  max-width: fit-content;
  border-radius: 50px;
}
.rounded {
  border-radius: 50%;
}
.questionOverlay {
  padding-left: 12px;
  margin-right: 12px;
  border-radius: 50px;
  background-color: #ccff23;
}
</style>
